module.exports = __webpack_public_path__ + "static/media/landing-bg2.26586e56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing-bg2.jpg
// module id = 791
// module chunks = 0